module.exports = __webpack_public_path__ + "media/什么是泰勒公式.ba8cb604.mp4";